import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../../constants/colors';
import { desktopMinWidth } from '../../../../utils/windowHelpers';
import { Link } from 'react-router-dom';
import Loading from '../../../components/Loading';

const MyTokens = ({ contentNotAccessible, tokens, loading = false }) => {
  const useStyles = makeStyles(theme =>
    createStyles({
      root: {
        margin: '64px 12px 80px 12px',
        position: 'relative',
        [desktopMinWidth]: {
          margin: '64px auto 84px auto',
          minHeight: 200,
        },
      },
      container: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 8,
        margin: '0 auto',
        [desktopMinWidth]: {
          gap: 40,
        },
      },
      item: {
        cursor: 'pointer',
        marginBottom: 24,
        '&:hover': {
          transform: 'scale(1.1)',
          transitionDuration: '0.6s',
        },
        [desktopMinWidth]: {
          marginBottom: 0,
        },
      },
      img: {
        borderRadius: 4,
        width: 142,
        height: 235,
        [desktopMinWidth]: {
          width: 230,
          height: 359,
        },
      },
      title: {
        fontSize: 14,
        color: colors.white_f2,
        marginTop: 8,
        maxWidth: 200,
        [desktopMinWidth]: {
          fontSize: 16,
          fontWeight: 500,
          maxWidth: 220,
        },
      },
      emptyTitle: {
        fontSize: 14,
        color: colors.white_f2,
        margin: '0 auto',
        maxWidth: 200,
        textAlign: 'center',
        [desktopMinWidth]: {
          fontSize: 16,
          fontWeight: 500,
          maxWidth: 220,
        },
      },
      defaultTitle: {
        marginTop: 8,
        width: 152,
        height: 28,
        [desktopMinWidth]: {
          width: 240,
          height: 34,
        },
      },
    }),
  );

  const classes = useStyles();
  const defaultImg =
    'https://d2oi1rqwb0pj00.cloudfront.net/lesan/nasio/skeleton.png';
  const defaultTitleImg =
    'https://d2oi1rqwb0pj00.cloudfront.net/lesan/nasio/text.png';
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {contentNotAccessible &&
          !loading &&
          [0, 1, 2, 3].map((item, index) => {
            return (
              <div key={index} className={classes.item}>
                <img
                  src={defaultImg}
                  className={classes.img}
                  alt="default image"
                />
                <div>
                  <img
                    src={defaultTitleImg}
                    className={classes.defaultTitle}
                    alt="default title"
                  />
                </div>
              </div>
            );
          })}
        {!contentNotAccessible &&
          !loading &&
          tokens?.map((token, index) => {
            const { metadata, contract } = token || {};
            const { image, description, name } = metadata || {};
            const contractAdd = contract?.address;
            const mintImage = image?.includes('https')
              ? image
              : image?.includes('ipfs://')
              ? `${process.env.REACT_APP_IPFS_BASE_URL}/${
                  image.split('ipfs://')[1]
                }`
              : `${process.env.REACT_APP_IPFS_BASE_URL}/${image}`;
            const tokenId = name?.split('#')[1];
            return (
              <Link to={`/details/${contractAdd}/${tokenId}`}>
                <div key={index} className={classes.item}>
                  <img src={mintImage} className={classes.img} alt={name} />
                  <div className={classes.title}>{description}</div>
                </div>
              </Link>
            );
          })}
      </div>
      {!contentNotAccessible && !loading && tokens?.length === 0 && (
        <div className={classes.emptyTitle}>
          No tokens with Nas Academy found. Please also ensure you log in with
          the right Metamask account.
        </div>
      )}
      {loading && <Loading />}
    </div>
  );
};

export default MyTokens;
